<ng-container *appTranslate="let t">
  <div class="kpi-dashboard">
    <div class="header-section">
      <div class="header-content">
        <div class="header-text">
          <h1 class="dashboard-title">
            <i class="pi pi-chart-line mr-2"></i>
            {{ t("kpi.dashboard.title") }}
          </h1>
          @if (kpisSignal(); as kpiData) {
            <p class="text-color-secondary">
              {{ t("kpi.dashboard.lastUpdated") }}:
              {{ kpiData.date | appDateTime: { timeStyle: "short" } }}
            </p>
          }
          @if (availableMonthsOptions().length > 1) {
            <div class="mt-3">
              <p-dropdown
                [options]="availableMonthsOptions()"
                [(ngModel)]="selectedMonth"
                optionLabel="label"
                optionValue="value"
                [placeholder]="t('kpi.selectMonth')"
                styleClass="w-full md:w-14rem"
                appendTo="body"
                [panelStyle]="{ 'min-width': '14rem' }"
              >
                <ng-template pTemplate="selectedItem" let-option>
                  <div class="flex items-center gap-2">
                    <i class="pi pi-calendar text-sm"></i>
                    <span class="font-medium">{{ option.label }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="item" let-option>
                  <div class="flex items-center justify-between p-2">
                    <span class="font-semibold">{{ option.label }}</span>
                    @if (option.value.year === currentMonth.year && option.value.month === currentMonth.month) {
                      <p-tag severity="info" class="ml-2">
                        {{ t("kpi.currentMonth") }}
                      </p-tag>
                    }
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          }
          @if (kpisSignal()?.includesVirtualBookings) {
            <p class="text-color-secondary text-sm mt-2">
              <i class="pi pi-info-circle mr-1"></i>
              {{ t("kpi.dashboard.preliminaryWarning") }}
            </p>
          }
        </div>
        <div class="header-actions">
          <button
            class="p-button p-button-rounded p-button-text"
            [class.p-button-success]="isPlaying()"
            [title]="isPlaying() ? t('kpi.pause') : t('kpi.play')"
            (click)="togglePlay()"
          >
            <i [class]="isPlaying() ? 'pi pi-pause' : 'pi pi-play'"></i>
          </button>
          <button
            class="p-button p-button-rounded p-button-text"
            [class.p-button-success]="autoRefreshEnabled()"
            [title]="autoRefreshEnabled() ? t('kpi.autoRefreshActive') : t('kpi.autoRefreshActivate')"
            (click)="toggleAutoRefresh()"
          >
            <i [class]="isRefreshing() ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"></i>
          </button>
          <button
            class="p-button p-button-rounded p-button-text"
            [title]="isCarouselMode() ? t('kpi.switchToGridView') : t('kpi.switchToCarouselView')"
            (click)="toggleLayoutMode()"
          >
            <i [class]="isCarouselMode() ? 'pi pi-table' : 'pi pi-images'"></i>
          </button>
          <button class="p-button p-button-rounded p-button-text" [title]="t('common.back')" [routerLink]="['/app']">
            <i class="pi pi-arrow-left"></i>
          </button>
        </div>
      </div>
    </div>

    @if (kpisSignal(); as kpiData) {
      <!-- Carousel View -->
      @if (isCarouselMode()) {
        <app-kpi-carousel-view
          [candidateKpis]="candidateKpis()"
          [organizationKpis]="organizationKpis()"
          [revenueKpis]="revenueKpis()"
          [accountsReceivableKpis]="accountsReceivableKpis()"
          [currentPanelIndex]="currentPanelIndex()"
          [prevIndex]="getPrevIndex()"
          [nextIndex]="getNextIndex()"
          (panelChange)="goToPanel($event)"
        />
      }

      <!-- Grid View -->
      @else {
        <app-kpi-grid-view
          [candidateKpis]="candidateKpis()"
          [organizationKpis]="organizationKpis()"
          [revenueKpis]="revenueKpis()"
          [accountsReceivableKpis]="accountsReceivableKpis()"
        />
      }
    } @else if (error()) {
      <div class="error-container">
        <i class="pi pi-exclamation-triangle text-red-500" style="font-size: 3rem"></i>
        <h2 class="mt-3">{{ t("kpi.error.title") }}</h2>
        <p class="text-color-secondary mt-2">{{ error() }}</p>
        <button class="p-button p-button-outlined mt-3" (click)="window.location.reload()">
          <i class="pi pi-refresh mr-2"></i>
          {{ t("kpi.error.reload") }}
        </button>
      </div>
    } @else if (isLoading()) {
      <div class="loading-container">
        <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
        <p class="mt-3">{{ t("loading") }}</p>
      </div>
    }
  </div>
</ng-container>
